import React, { useState, useEffect } from 'react';
import { Link, router, usePage } from '@inertiajs/react';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import axios from 'axios';
import CreditsInfo from '../../Components/CreditsInfo'; // Using alias for import
import './Index.css';
import { plotPointOptions } from './plotPointOptions'; // Import the plotPointOptions

const PlotPoints = ({ initialPlotPoints = [], movie_hash, sceneMap = {}, sceneTextMap = {}, credits: initialCredits, user_email, movie_title, characters = [], settings = [] }) => {
    const { props } = usePage();
    const [plotPoints, setPlotPoints] = useState(initialPlotPoints);
    const [characterDescriptions, setCharacterDescriptions] = useState(characters);
    const [settingDescriptions, setSettingDescriptions] = useState(settings);
    const [processing, setProcessing] = useState(false);
    const [regenInstructions, setRegenInstructions] = useState('');
    const [credits, setCredits] = useState(initialCredits);
    const [selectedSceneText, setSelectedSceneText] = useState('');
    const [flash, setFlash] = useState(props.flash);
    const [selectedStructure, setSelectedStructure] = useState("");
    const [plotPointsText, setPlotPointsText] = useState("");
    const [changedPlotPoints, setChangedPlotPoints] = useState({});
    const [loadingStates, setLoadingStates] = useState(characterDescriptions.map(() => false));
    const [isGenerating, setIsGenerating] = useState(false);

    const [changedDescriptions, setChangedDescriptions] = useState({});

    useEffect(() => {
        // Initialize the changedPlotPoints state only once
        if (Object.keys(changedPlotPoints).length === 0) {
            const initialChangedState = plotPoints.reduce((acc, plotPoint, index) => {
                acc[index] = false;
                return acc;
            }, {});
            setChangedPlotPoints(initialChangedState);
        }
    }, [plotPoints, changedPlotPoints]);

    const handlePlotPointChange = (index, field, value) => {
        const updatedPlotPoints = [...plotPoints];
        updatedPlotPoints[index][field] = value;
        setPlotPoints(updatedPlotPoints);

        setChangedPlotPoints({
            ...changedPlotPoints,
            [index]: true
        });
    };

    useEffect(() => {
        // Initialize the changedDescriptions state only once
        if (Object.keys(changedDescriptions).length === 0) {
            const initialChangedState = characterDescriptions.reduce((acc, character, index) => {
                acc[index] = false;
                console.log("acc", acc);
                console.log("index", index);
                return acc;
            }, {});
            setChangedDescriptions(initialChangedState);
        }
    }, [characterDescriptions, changedDescriptions]);

    const handleDescriptionChange = (index, value) => {
        const updatedCharacters = [...characterDescriptions];
        updatedCharacters[index].description = value;
        setCharacterDescriptions(updatedCharacters);

        setChangedDescriptions({
            ...changedDescriptions,
            [index]: true
        });
    };

    useEffect(() => {
        console.log('Props flash:', props.flash); // Log props
        if (props.flash?.success) {
            // console.log("SUCC");
            toast.success(props.flash.success);
        }
        if (props.flash?.error) {
            // console.log("ERROR");
            toast.error(props.flash.error);
        }
        if (props.flash?.message) {
            toast.info(props.flash.message);
        }
        if (props.flash?.status) {
            toast.info(props.flash.status);
        }
    }, [props.flash]);

    useEffect(() => {
        if (props.plotPoints) {
            setPlotPoints(props.plotPoints);
        }
        if (props.characters) {
            setCharacterDescriptions(props.characters);
        }
        if (props.settings) {
            setSettingDescriptions(props.settings);
        }

        console.log('Props useeff:', props); // Log props
        // Fetch the latest credits
        // fetchCredits();
    }, [props.plotPoints, props.characters, props.settings, movie_hash]);

    const fetchCredits = async () => {
        console.log('Props fetch:', props); // Log props
        try {
            const response = await axios.get(`/credits/${movie_hash}`);
            setCredits(response.data.credits);
        } catch (error) {
            console.error('Error fetching credits:', error);
            toast.error('Error fetching credits.');
        }
    };

    const addPlotPoint = (index) => {
        console.log('Props:', props); // Log props
        const orderNumber = index !== null && index < plotPoints.length ? plotPoints[index].order_number : plotPoints.length + 1;
        const newPlotPoint = {
            order_number: orderNumber,
            scene_number: Object.keys(sceneMap).length > 0 ? Object.keys(sceneMap)[0] : '', // Default to the first scene number if available
            title: '',
            text: '',
            voice_over_text: ''
        };
        const updatedPlotPoints = [...plotPoints];
        updatedPlotPoints.splice(index !== null ? index : plotPoints.length, 0, newPlotPoint);
        setPlotPoints(reorderPlotPoints(updatedPlotPoints));
    };

    const reorderPlotPoints = (plotPoints) => {
        return plotPoints.map((plotPoint, index) => ({
            ...plotPoint,
            order_number: index + 1
        }));
    };

    const handleSaveClick = (plotPoint, index) => {
        const form = document.getElementById(`plot-point-form-${index}`);
        if (form.checkValidity()) {
            savePlotPoint(plotPoint, index);
        } else {
            form.reportValidity();
        }
    };

    const savePlotPoint = (plotPoint, index) => {
        const data = { ...plotPoint, movie_hash };

        if (plotPoint.id) {
            router.put(`/plot-points/${plotPoint.id}`, data, {
                preserveState: true,
                preserveScroll: true,
                onSuccess: () => {
                    toast.success('Plot point saved successfully!');
                    fetchCredits(); // Fetch the latest credits after saving
                }
            });
        } else {
            router.post('/plot-points', data, {
                preserveState: true,
                preserveScroll: true,
                onSuccess: () => {
                    toast.success('Plot point saved successfully!');
                    fetchCredits(); // Fetch the latest credits after saving
                }
            });
        }
    };

    const deletePlotPoint = (id, index) => {
        const confirmed = confirm('Are you sure you want to delete this plot point?');
        if (confirmed) {
            if (id) {
                router.delete(`/plot-points/${id}`, {
                    preserveState: true,
                    preserveScroll: true,
                    onSuccess: () => {
                        const updatedPlotPoints = [...plotPoints];
                        updatedPlotPoints.splice(index, 1);
                        setPlotPoints(reorderPlotPoints(updatedPlotPoints));
                        toast.success('Plot point deleted successfully!');
                        fetchCredits(); // Fetch the latest credits after deleting
                    }
                });
            } else {
                const updatedPlotPoints = [...plotPoints];
                updatedPlotPoints.splice(index, 1);
                setPlotPoints(reorderPlotPoints(updatedPlotPoints));
                toast.success('Plot point deleted successfully!');
                fetchCredits(); // Fetch the latest credits after deleting
            }
        }
    };

    const handleSaveDescriptionClick = (description, index, type) => {
        const form = document.getElementById(`description-form-${type}-${index}`);
        if (form.checkValidity()) {
            saveDescription(description, index, type);
        } else {
            form.reportValidity();
        }
    };

    const saveDescription = async (description, index, type) => {
        const data = { description: description.description };
        const csrfToken = document.querySelector('meta[name="csrf-token"]').getAttribute('content');

        try {
            const response = await fetch(`/descriptions/${description.id}`, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                    'X-CSRF-TOKEN': csrfToken
                },
                body: JSON.stringify(data)
            });

            if (response.ok) {
                const responseData = await response.json();
                console.log('Description saved successfully!', responseData);
                toast.success('Description saved successfully!');
                fetchCredits(); // Fetch the latest credits after saving
            } else {
                const errorData = await response.json();
                console.error('Error saving description:', errorData);
                toast.error('Failed to save description.');
            }
        } catch (error) {
            console.error('There was a problem with the fetch operation:', error);
            toast.error('An error occurred while saving the description.');
        }
    };

    const generate = () => {
        if (credits < plotPoints.length * 2) {
            toast.error('You do not have enough credits to create this video.');
            return;
        }
        setIsGenerating(true);
        router.post('/generate', { movie_hash }, {
            onFinish: () => {
                setIsGenerating(false);
            }
        });
    };

    const generatepp = () => {
        if (credits < 5) {
            toast.error('You do not have enough credits.');
            return;
        }
        setProcessing(true);
        router.post('/generatepp', { movie_hash, instructions: regenInstructions }, {
            onFinish: () => {
                setProcessing(false);
                fetchCredits(); // Fetch the latest credits after generating plot points
            }
        });
    };

    const handleSceneTextModal = (sceneNumber) => {
        const sceneText = sceneTextMap[sceneNumber] || "No text available for this scene.";
        const formattedText = sceneText.split('\n').map((line, index) => (
            <React.Fragment key={index}>
                {line}
                <br />
            </React.Fragment>
        ));
        setSelectedSceneText(formattedText);
        const sceneTextModal = new bootstrap.Modal(document.getElementById('sceneTextModal'));
        sceneTextModal.show();
    };

    const handlePPSelectChange = (structure) => {
        setSelectedStructure(structure);
        setRegenInstructions(plotPointOptions[structure].join("\n"));
    };


    return (
        <div className="container">
            {processing && (
                <div className="fullscreen-spinner-overlay">
                    <div className="spinner"></div>
                    <div className="spinner-text">
                        This takes on average around 2 minutes.<br />
                    </div>
                </div>
            )}
            <ToastContainer />
            <CreditsInfo
                movie_title={movie_title}
                movie_hash={movie_hash}
                initialCredits={credits}
                user_email={user_email}
            />
            <br />

            <div className="alert alert-info" role="alert" style={{ backgroundColor: '#e9ecef', padding: '20px' }}>
                <h4 className="alert-heading">How do you want to present the screenplay?</h4>
                <p>Do you want to tell the story?  Explain a character arc?  Give a teaser?  Spend time highlighting the Unique Selling Proposition?
                    <br />Or maybe you want to set up the world and the premise.
                    <br />Put that in the instructions to the AI.
                    <br />Or leave the instructions blank, see what the AI does and iterate from there.
                    <br /><br />AI will create video sections that will have images and voice over text.
                </p>
            </div>
            <center>
                {/* {plotPoints && plotPoints.length > 0 && (
                    <button className="btn  btn-wild btn-success mb-3" onClick={generate} >Create Prompts for Video ({plotPoints.length} credits)</button>
                )} */}
            </center>
            <div className="row mb-3">
                <div className="col">
                    <h2>Generate Video Sections</h2>
                    <div className="d-flex align-items-center mb-3">
                        <span className="me-3">Use a preset format or type in your own</span>
                        <div className="dropdown">
                            <button className="btn btn-secondary dropdown-toggle" type="button" id="dropdownMenuButton" data-bs-toggle="dropdown" aria-expanded="false">
                                {selectedStructure || "Select Plot Point Structure"}
                            </button>
                            <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton" style={{ backgroundColor: 'white' }}>
                                {Object.keys(plotPointOptions).map((structure) => (
                                    <li key={structure}>
                                        <a className="dropdown-item" href="#" onClick={() => handlePPSelectChange(structure)} style={{ color: 'black' }}>
                                            {structure}
                                        </a>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    </div>
                    <textarea
                        value={regenInstructions}
                        onChange={(e) => setRegenInstructions(e.target.value)}
                        className="form-control mt-3"
                        placeholder="Enter instructions for generating video sections (optional)..."
                    ></textarea>
                    {plotPoints && plotPoints.length > 0 && (
                        <button className="btn btn-primary mt-2" onClick={generatepp} style={{ background: 'linear-gradient(to right, #ff7e5f, #feb47b)', border: 'none' }}>Generate Video Sections (5 credits)</button>
                    )}
                    {plotPoints && plotPoints.length === 0 && (
                        <button className="btn btn-primary mt-2 btn-wild" onClick={generatepp} >Generate Video Sections  (5 credits)</button>
                    )}
                </div>
            </div>

        </div>
    );
};

export default PlotPoints;
